export const DEFAULT_GRAPHQL_FETCH_POLICY = "cache-and-network";
export const DEFAULT_GRAPHQL_NEXT_FETCH_POLICY = "cache-first";
export const DEFAULT_GRAPHQL_ERROR_POLICY = "all";
export const DEFAULT_GRAPHQL_POLL_INTERVAL = 10000;
export const DEFAULT_GRAPHQL_PAGINATION = "{page:1,size:5}";
export const DEFAULT_GRAPHQL_MUTATION_ERROR_MESSAGE = "Lo sentimos, hubo un error al intentar guardar la información, favor de intentarlo más tarde o ponerse en contacto con el proveedor del sistema.";
export const DEFAULT_GRAPHQL_SUCCESS_MESSAGE = "Buen trabajo, información guardada exitosamente";
export const TABLE_NO_SELECTABLE_CRITERIA = "noSelectable";
export const DEFAULT_GRAPHQL_MUTATION_FAKER = "mutation {fake{ error id ok}}";
export const DEFAULT_GRAPHQL_QUERY_FAKER = "query {fake{ error id ok}}";